import React from "react";

export default function ActivityLog() {
  return (
    <div>
      <p>ActivityLog</p>
    </div>
  );
}
